import { isEqual } from 'lodash';

import { blankStudent } from '../constants/inviteStudentsDefaults';
import { type Student } from '../types/inviteStudentsTypes';

export const removeBlankStudents = (students: Student[]): Student[] => students.filter((student) => !isEqual(student, blankStudent));
